import { createActionGroup, props } from '@ngrx/store';
import { ExaminationResponse } from '@pixacare/dtos';
import { EXAMINATIONS_FEATURE_KEY } from './examinations.selector';
import { ExaminationResponsesByExaminationFormId } from './models/examination-response-by-examination-form-id';

export const examinationsActions = createActionGroup({
  source: EXAMINATIONS_FEATURE_KEY,
  events: {
    'Update examinations state': props<{
      clientCode: string;
      patientId: number;
      departmentId?: number;
      examinations: ExaminationResponsesByExaminationFormId;
    }>(),
    'Add examination': props<{
      clientCode: string;
      departmentId?: number;
      examinationResponse: ExaminationResponse;
    }>(),
    'Delete examination': props<{
      clientCode: string;
      patientId: number;
      departmentId?: number;
      examinationId: number;
    }>(),
  },
});
